import React from 'react';
import FormGroup from "../../components/formGroup";
import MySelect from "../../components/form/mySelect";
import {isObject} from "lodash";

function ChoixDiplome(props) {
    const diplome = isObject(props.selected)
        ? props.selected
        : props.parameters.find(f => f.value === props.selected);

    return (
        <div>
            <FormGroup label={"Choix du diplôme"}
                       name={"DiplomeID"}
                       type={MySelect}
                       value={diplome}
                       options={props.parameters}
                       onChange={props.onChange.bind(this)}
                       required={true}/>
        </div>
    );
}

export default ChoixDiplome;